var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211 12.3633H27.0049C26.694 10.9515 26.1315 9.59561 25.3513 8.37744L26.8081 6.92068C27.1513 6.5775 27.1511 6.02068 26.8081 5.67773L24.3223 3.19189C23.9791 2.84865 23.4226 2.84865 23.0793 3.19189L21.6226 4.64865C20.4043 3.86848 19.0485 3.30598 17.6367 2.99502V0.878906C17.6367 0.393516 17.2432 0 16.7578 0H13.2422C12.7568 0 12.3633 0.393516 12.3633 0.878906V2.99502C10.9515 3.30598 9.59566 3.86848 8.3775 4.64859L6.92074 3.19184C6.57756 2.84859 6.02104 2.84859 5.67779 3.19184L3.19189 5.67773C2.84865 6.02092 2.84889 6.57773 3.19189 6.92068L4.64865 8.37744C3.86848 9.59561 3.30604 10.9515 2.99508 12.3633H0.878906C0.393516 12.3633 0 12.7568 0 13.2422V16.7578C0 17.2432 0.393516 17.6367 0.878906 17.6367H2.99508C3.30604 19.0484 3.86848 20.4042 4.64865 21.6225L3.19189 23.0791C2.84865 23.4223 2.84889 23.9791 3.19189 24.3221L5.67773 26.8081C6.02086 27.1513 6.57768 27.1512 6.92068 26.8081L8.37744 25.3513C9.59555 26.1315 10.9515 26.694 12.3632 27.0049V29.1211C12.3632 29.6065 12.7567 30 13.2421 30H16.7578C17.2431 30 17.6367 29.6065 17.6367 29.1211V27.0049C19.0484 26.694 20.4043 26.1315 21.6224 25.3513L23.0792 26.8081C23.4223 27.1513 23.9791 27.1511 24.3221 26.8081L26.808 24.3221C27.1513 23.979 27.1511 23.4221 26.808 23.0792L25.3513 21.6226C26.1314 20.4043 26.6939 19.0484 27.0049 17.6368H29.1211C29.6065 17.6368 30 17.2433 30 16.7579V13.2422C30 12.7568 29.6065 12.3633 29.1211 12.3633Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.08984C10.6383 7.08984 7.08984 10.6383 7.08984 15C7.08984 19.3617 10.6383 22.9102 15 22.9102C19.3617 22.9102 22.9102 19.3617 22.9102 15C22.9102 10.6383 19.3617 7.08984 15 7.08984ZM15.8789 18.5156C15.8789 19.001 15.4854 19.3945 15 19.3945C14.5146 19.3945 14.1211 19.001 14.1211 18.5156V15C14.1211 14.5146 14.5146 14.1211 15 14.1211C15.4854 14.1211 15.8789 14.5146 15.8789 15V18.5156ZM15 12.3633C14.5146 12.3633 14.1211 11.9698 14.1211 11.4844C14.1211 10.999 14.5146 10.6055 15 10.6055C15.4854 10.6055 15.8789 10.999 15.8789 11.4844C15.8789 11.9698 15.4854 12.3633 15 12.3633Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15,
    y1: 30,
    x2: 15,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AA6F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15,
    y1: 22.9102,
    x2: 15,
    y2: 7.08984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.b1eaeac01cbd825285883f5ed911dd0a.svg";
export { ForwardRef as ReactComponent };